import { c as _c } from "react/compiler-runtime";
import { getCreateWaveStepStatus } from "@/helpers/waves/waves.helpers";
import { CreateWaveStep, CreateWaveStepStatus } from "@/types/waves.types";
import CreateWavesMainStepIcon from "./CreateWavesMainStepIcon";
import CreateWavesMainStepConnectionLine from "./CreateWavesMainStepConnectionLine";
export default function CreateWavesMainStep(t0) {
  const $ = _c(23);
  const {
    isLast,
    label,
    step,
    stepIndex,
    activeStepIndex,
    onStep
  } = t0;
  let t1;
  if ($[0] !== activeStepIndex || $[1] !== stepIndex) {
    t1 = getCreateWaveStepStatus({
      stepIndex,
      activeStepIndex
    });
    $[0] = activeStepIndex;
    $[1] = stepIndex;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const stepStatus = t1;
  const isDone = stepStatus === CreateWaveStepStatus.DONE;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      [CreateWaveStepStatus.DONE]: "tw-text-iron-600 tw-font-semibold tw-delay-0",
      [CreateWaveStepStatus.ACTIVE]: "tw-text-primary-400 tw-font-bold tw-delay-500",
      [CreateWaveStepStatus.PENDING]: "tw-text-iron-600 tw-font-semibold tw-delay-0"
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const LABEL_CLASSES = t2;
  let t3;
  if ($[4] !== isDone || $[5] !== isLast) {
    t3 = !isLast && <CreateWavesMainStepConnectionLine done={isDone} />;
    $[4] = isDone;
    $[5] = isLast;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !isDone;
  let t5;
  if ($[7] !== onStep || $[8] !== step) {
    t5 = () => onStep(step);
    $[7] = onStep;
    $[8] = step;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = `${LABEL_CLASSES[stepStatus]} tw-text-base tw-transform tw-transition tw-ease-out tw-duration-300`;
  let t7;
  if ($[10] !== label || $[11] !== t6) {
    t7 = <span className="tw-mr-6 tw-flex tw-min-w-0 tw-flex-col"><span className={t6}>{label}</span></span>;
    $[10] = label;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== stepStatus) {
    t8 = <span className="tw-flex tw-h-9 tw-items-center"><CreateWavesMainStepIcon stepStatus={stepStatus} /></span>;
    $[13] = stepStatus;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t7 || $[18] !== t8) {
    t9 = <button type="button" disabled={t4} onClick={t5} className="tw-bg-transparent tw-p-0 tw-border-none focus:tw-outline-none tw-group tw-relative tw-flex tw-items-center">{t7}{t8}</button>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t3 || $[21] !== t9) {
    t10 = <div className="tw-relative tw-mb-11">{t3}{t9}</div>;
    $[20] = t3;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}